module.exports = __webpack_public_path__ + "img/lamp.1fcf2c6.png";